<template>

    <div class="container-center">
        <div class="inviteInfo solid">
            <p class="title" >{{ detailData.title }}</p>
            <p>发布时间：{{ detailData.createDate }}</p>
        </div>

        <div class="inviteInfo dashed">
            <h5>洽谈信息</h5>
            <el-row><el-col :span="3">地点：</el-col><el-col :span="21">{{ detailData.address }}</el-col></el-row>
            <el-row><el-col :span="3">时间：</el-col><el-col :span="21">{{ detailData.discussDate }}</el-col></el-row>
        </div>

        <div class="inviteInfo dashed">
            <h5>通知内容</h5>
            <el-row>
                <el-col :span="3">内容：</el-col><el-col :span="21">{{ detailData.content }}</el-col></el-row>
            <!-- <div class="nego-content">
                {{ detailData.content }}
            </div> -->
        </div>

        

        <h5>附件</h5>
        <div v-if="detailData.baseFileList.length == 0" class="no-data-tip"></div>
        <ul v-else class="invite-mng-list">
            <li v-for="li in detailData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a> <span style="float: right;">{{ li.createDate }}</span></li>
        </ul>

    </div>

</template>
<script>
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'

export default {
    name: "invite-nego-detail",
    data () {
        return {
            downloadApi: `${util.baseUrl}rest/file/down`,

            detailData: {
                baseFileList: []
            }
        }
    },
    methods: {
        getDetailData () {
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/discuss/getDiscussInfo',{
                msgId: this.$route.params.fid
            }).then((res)=>{
                loading.close()
                if(res.data.result) {
                    this.detailData = res.data.value;
                    this.$root.navs.push(
                        {name: this.$route.params.name, path:'/inviteMngInfo/'+ encodeURIComponent(this.$route.params.id)},
                        {name:'洽谈通知', path:'/inviteNego/'+ encodeURIComponent(this.$route.params.id) +'/'+ encodeURIComponent(this.$route.params.name) },
                        {name: this.detailData.title}
                    )
                }
        })
        },
    },
    created () {
        this.$root.navs = [
            {name:'招标管理',path:'/inviteMngList'}
        ]
        this.$root.headImage.src = banner
        this.$root.activeIndex = 'invite'
        this.$root.isPublic = false
    },
    mounted () {
        this.getDetailData()
    },

}

</script>
<style scoped>
@import '../../../assets/common.css';

a {color:var(--cMain);}

ul {padding: 0;margin:0;}
ul li {list-style:none;}

ul.invite-mng-list li {padding:14px 12px;font-size:14px;}
ul.invite-mng-list li + li {border-top:1px dashed #E5E6E5;}
ul.invite-mng-list li a {color:var(--cTxt1);text-decoration:none;}
ul.invite-mng-list li a:hover {color:var(--cMain);}

.container-center {padding:40px 0;}

.inviteInfo {font-size: 14px;}
.inviteInfo.solid {height: 100px;border-bottom: 1px solid #E6E7E6;padding-top: 50px;}
.inviteInfo.solid > p {margin: 0 0 24px 0;color: #000;font-size: 14px;text-align:center;}
.inviteInfo.solid > p.title {font-size: 18px;font-weight: bold;}
.inviteInfo.solid > p.title.strategy::after {content: '战略';display: inline-block;width: 40px;height: 22px;line-height: 22px;text-align: center;font-size: 12px;font-weight: normal;color: #fff;background: var(--cMint);border-radius: 2px;vertical-align: bottom;margin-left: 10px;}
.inviteInfo.dashed {padding-bottom: 10px;border-bottom: 1px dashed #E6E7E6;}
.inviteInfo.dashed.segment {margin-bottom:20px;}
.inviteInfo h5 {color: #252525;font-size: 15px;margin: 16px 0;}
.inviteInfo h5::before {content: '';display: inline-block;width: 5px;height: 5px;background: var(--cMain);vertical-align: middle;margin: 0 10px;}
.inviteInfo .el-row {margin-bottom: 12px;}
.inviteInfo .el-col-3,
.inviteInfo .el-col-6 {color: #5f5f5f;text-align: right;}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteNegoDetail.vue